import { useEffect, useState } from 'react'

import { color } from 'd3-color'
import { interpolateRgb } from 'd3-interpolate'
import { useSelector } from 'react-redux'

import SmallScoreSummaryCard from './SmallScoreSummaryCard'
import LargeScoreSummaryCard from './LargeScoreSummaryCard'
import { selectUser } from '../../reducers/UserReducer'

import '../../assets/score-summary-card.scss'

const INTERPOLATE = interpolateRgb('#108ee9', '#108ee9')
const FILL_COLOR = INTERPOLATE(50 / 100)
const GRADIENT_STOPS = [
  {
    key: '0%',
    stopColor: color(FILL_COLOR).darker(0.5).toString(),
    stopOpacity: 1,
    offset: '0%'
  },
  {
    key: '50%',
    stopColor: FILL_COLOR,
    stopOpacity: 0.75,
    offset: '50%'
  },
  {
    key: '100%',
    stopColor: color(FILL_COLOR).brighter(0.5).toString(),
    stopOpacity: 0.5,
    offset: '100%'
  }
]

const ScoreSummaryCard = ({ title, size = 'small', request, entityId, end, start, score, isInstitution, onChange }) => {
  const user = useSelector(selectUser)

  const [loading, setLoading] = useState(true)
  const [entityData, setEntityData] = useState({})
  const [colorCircle, setColorCircle] = useState('rgba(243,243,243,255)')

  useEffect(() => {
    if (!!entityId && user !== null) {
      const fetchingId = isInstitution ? -1 : entityId

      if (score) {
        setEntityData(score)
      } else {
        setLoading(true)

        request(user, { id: entityId }, end.format('YYYY-MM-DD'), start.format('YYYY-MM-DD'), true).then(json => {
          if (json) {
            setEntityData(json)
            onChange(fetchingId, json)
          }

          setLoading(false)
        })
      }
    }
  }, [start, end, user, entityId])

  useEffect(() => {
    if (entityData !== null && entityData.responseRate > 0) {
      setColorCircle(FILL_COLOR)
    } else {
      setColorCircle('rgba(243,243,243,255)')
    }
  }, [entityData?.responseRate])

  const Card = size === 'small' ? SmallScoreSummaryCard : LargeScoreSummaryCard

  return (
    <Card
      title={title}
      loading={loading}
      entityData={entityData}
      colorCircle={colorCircle}
      gradientStops={GRADIENT_STOPS}
      fillColor={FILL_COLOR}
    />
  )
}

export default ScoreSummaryCard
